export default "__VITE_ASSET__CFOFJxls__"